import { connect } from "react-redux";
import React, { useState } from "react";

import { getPatientProfile } from "@/redux/actions/auth";
import { patientRequests } from "@/api/(requests)/patient";
import { Portal } from "@/components/Common/Modal/Portal";

import { CompletePreferredName } from "./CompletePreferredName";
import { CompleteProfileAddress } from "./CompleteProfileAddress";
import { CompleteProfileEmergencyContact } from "./CompleteProfileEmergencyContact";
import CompleteProfileHeaderWidget from "./CompleteProfileHeaderWidget";
import { CompleteProfilePhysician } from "./CompleteProfilePhysician";

import "./styles.scss";

export const COMPLETE_PROFILE_STEPS = Object.freeze({
  ADDRESS: "Address",
  EMERGENCY_CONTACT: "Emergency Contact",
  PREFERRED_NAME: "Preferred Name",
  PRIMARY_CARE_PHYSICIAN: "Primary Care Physician",
});

class CompleteProfileBodyComponent extends React.Component {
  render() {
    const {
      closeModal,
      currentCompleteProfileStep,
      setCurrentCompleteProfileStep,
      setUpdatedProfile,
      updatedProfile,
    } = this.props;

    const submitHandler = async (formData) => {
      const mergedAccountData = { ...updatedProfile, ...formData };

      setUpdatedProfile(mergedAccountData);
      await patientRequests.update_profile({ data: formData });
      this.props.getPatientProfile();
    };

    const formProps = {
      closeModal,
      profile: updatedProfile,
      setCurrentCompleteProfileStep,
      submitHandler,
    };

    return (
      <div className="workflow-container">
        {currentCompleteProfileStep === COMPLETE_PROFILE_STEPS.ADDRESS && (
          <CompleteProfileAddress {...formProps} />
        )}
        {currentCompleteProfileStep === COMPLETE_PROFILE_STEPS.EMERGENCY_CONTACT && (
          <CompleteProfileEmergencyContact {...formProps} />
        )}
        {currentCompleteProfileStep === COMPLETE_PROFILE_STEPS.PRIMARY_CARE_PHYSICIAN && (
          <CompleteProfilePhysician {...formProps} />
        )}
        {currentCompleteProfileStep === COMPLETE_PROFILE_STEPS.PREFERRED_NAME && (
          <CompletePreferredName {...formProps} />
        )}
      </div>
    );
  }
}

const CompleteProfileBody = connect(null, { getPatientProfile })(CompleteProfileBodyComponent);

const CompleteProfileWidget = (props) => {
  const { profile } = props;
  const [currentCompleteProfileStep, setCurrentCompleteProfileStep] = useState(
    COMPLETE_PROFILE_STEPS.ADDRESS,
  );
  const completeProfileSteps = [
    COMPLETE_PROFILE_STEPS.ADDRESS,
    COMPLETE_PROFILE_STEPS.EMERGENCY_CONTACT,
    COMPLETE_PROFILE_STEPS.PRIMARY_CARE_PHYSICIAN,
    COMPLETE_PROFILE_STEPS.PREFERRED_NAME,
  ];
  const [updatedProfile, setUpdatedProfile] = useState(profile);
  const [closeHandler, setCloseHandler] = useState(null);
  const closeModal = () => setCloseHandler(true);

  return (
    <Portal
      className="CompleteProfileWidget--modal"
      headerRender={
        <CompleteProfileHeaderWidget
          completeProfileSteps={completeProfileSteps}
          currentCompleteProfileStep={currentCompleteProfileStep}
        />
      }
      isBottomCloseActive={false}
      openButtonRender={<span>Complete aptihealth Profile</span>}
      triggerModalStateChange={closeHandler}
    >
      <CompleteProfileBody
        closeModal={closeModal}
        currentCompleteProfileStep={currentCompleteProfileStep}
        setCurrentCompleteProfileStep={setCurrentCompleteProfileStep}
        setUpdatedProfile={setUpdatedProfile}
        updatedProfile={updatedProfile}
      />
    </Portal>
  );
};

export default CompleteProfileWidget;
